<template>
  <v-footer class="footer-info bg-primary white pt-10 pb-2">
    <v-container>
      <v-row
        no-gutters
        class="w-100"
      >
        <div>
          <v-img
            src="@/images/footer-logo.png"
            contain
            width="200"
          />
        </div>
      </v-row>
      <v-row
        class="w-100 mt-10 footer-info__links"
        no-gutters
      >
        <div
          v-for="(link, index) in links"
          :key="'footer-link-'+index"
        >
          <router-link
            :to="link.to"
            :class="{'ml-8': index > 0}"
            class="text-white"
          >
            {{ link.text }}
          </router-link>
        </div>
      </v-row>
      <v-divider
        class="mt-10 mb-5"
        :thickness="2"
      />
      <v-row
        no-gutters
        class="w-100"
      >
        <v-col
          cols="12"
          sm="8"
          class="footer-info__copyright"
        >
          <small>© {{ year }} Weld Linking. All rights reserved.</small>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          class="footer-info__terms"
        >
          <v-row
            no-gutters
            justify="end"
          >
            <template
              v-for="(link, index) in bottomLinks"
              :key="'footer-link-'+index"
            >
              <router-link
                :to="link.to"
                :class="{'ml-8': index > 0}"
                class="text-white"
              >
                {{ link.text }}
              </router-link>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue'
import {useDisplay} from "vuetify"
import home from "@/mixins/home"

export default defineComponent({
  mixins: [home],
  setup() {
    const display = ref(useDisplay())
    return { display: display }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      bottomLinks: [
        {
          text: 'Terms',
          to: this.$routeTo(this.ROUTES.TERMS),
        },
        {
          text: 'Privacy',
          to: this.$routeTo(this.ROUTES.PRIVACY_POLICY),
        },
      ]
    }
  },
  computed: {
    links() {
      return [
        ...(this.$auth.loggedIn && this.$auth.isCompany() ? [{
          text: this.$auth.loggedIn ? 'Dashboard' : 'Home',
          to: this.homeRoute,
        }] : []),
        ...(this.$auth.loggedIn ? [{
          text: 'Home',
          to: this.$routeTo(this.ROUTES.HOME),
        }] : []),
        {
          text: 'Find Talent',
          to: this.$routeTo(this.ROUTES.FIND_TALENT),
        },
        {
          text: 'Find Work',
          to: this.$routeTo(this.ROUTES.FIND_WORK),
        },
        {
          text: 'Contact',
          to: this.$routeTo(this.ROUTES.CONTACT_US),
        },
      ]
    }
  },
})
</script>

<style scoped lang="scss">
.footer-info {
  flex-direction: column;
  &__links {
    @media (max-width: 600px) {
      div {
        width: 50%;
        margin: 5px 0;
        a {
          margin-left: 0!important;
        }
      }
    }
  }
  @media (max-width: 599px) {
    &__copyright {
      order: 2;
    }
    &__terms {
      order: 1;
      :deep(.v-row) {
        justify-content: start !important;
      }
    }
  }
}
</style>
